'use client';
var caseInsensitiveMatch = function(a, b) {
    return a.toLowerCase().includes(b.toLowerCase());
};

export { caseInsensitiveMatch };
